module.exports = __webpack_public_path__ + "static/media/logo_80_pl.7a5ce4fc.png";